import Vue from 'vue'

const setSkipSlideById = (state, payload) => {
  Vue.set(state.skipSlides, payload.id, payload.value)
}
const clearSkipSlides = (state) => {
  state.skipSlides = {}
}

const setSkipSlides = (state, payload) => {
  state.skipSlides = { ...state.skipSlides, ...payload }
}

export default {
  setSkipSlideById,
  clearSkipSlides,
  setSkipSlides,
}
